export default {
    title: 'Lecteurs de médias',
    description: 'Gérez les préréglages de lecteurs au niveau de l\'organisation. Ces préréglages sont disponibles dans tous les espaces de travail.',
    logo: 'Logo du lecteur',
    logoDescription: 'Uploadez un logo par défaut pour tous les lecteurs intégrés. Les espaces peuvent le remplacer par leur propre logo.',
    logoHelper: 'PNG, JPEG ou WebP. Recommandé : fond transparent.',
    logoSaved: 'Paramètres du logo enregistrés',
    logoError: 'Échec de l\'enregistrement des paramètres du logo',
}
